import util from '../util';

export const FEEDVIEW = 'FEEDVIEW';
export const FEEDVIEWS = 'FEEDVIEWS';
export const FEEDVIEW_CREATE = 'FEEDVIEW_CREATE';
export const FEEDVIEW_MODIFY = 'FEEDVIEW_MODIFY';
export const FEEDVIEW_MODIFY_TMP = 'FEEDVIEW_MODIFY_TMP';
export const RESET_FEEDVIEW = 'RESET_FEEDVIEW';
export const DELETE_FEEDVIEW = 'DELETE_FEEDVIEW';

export const FEEDVIEWS_REQUEST = util.requestType(FEEDVIEWS);
export const FEEDVIEWS_SUCCESS = util.successType(FEEDVIEWS);
export const FEEDVIEWS_FAILURE = util.failureType(FEEDVIEWS);

export const FEEDVIEW_REQUEST = util.requestType(FEEDVIEW);
export const FEEDVIEW_SUCCESS = util.successType(FEEDVIEW);
export const FEEDVIEW_FAILURE = util.failureType(FEEDVIEW);

export const CREATE_FEEDVIEW_REQUEST = util.requestType(FEEDVIEW_CREATE);
export const CREATE_FEEDVIEW_SUCCESS = util.successType(FEEDVIEW_CREATE);
export const CREATE_FEEDVIEW_FAILURE = util.failureType(FEEDVIEW_CREATE);

export const MODIFY_FEEDVIEW_REQUEST = util.requestType(FEEDVIEW_MODIFY);
export const MODIFY_FEEDVIEW_SUCCESS = util.successType(FEEDVIEW_MODIFY);
export const MODIFY_FEEDVIEW_FAILURE = util.failureType(FEEDVIEW_MODIFY);

export const MODIFY_FEEDVIEW_TMP_REQUEST =
  util.requestType(FEEDVIEW_MODIFY_TMP);
export const MODIFY_FEEDVIEW_TMP_SUCCESS =
  util.successType(FEEDVIEW_MODIFY_TMP);
export const MODIFY_FEEDVIEW_TMP_FAILURE =
  util.failureType(FEEDVIEW_MODIFY_TMP);

export const DELETE_FEEDVIEW_REQUEST = util.requestType(DELETE_FEEDVIEW);
export const DELETE_FEEDVIEW_SUCCESS = util.successType(DELETE_FEEDVIEW);
export const DELETE_FEEDVIEW_FAILURE = util.failureType(DELETE_FEEDVIEW);
